module.exports = __webpack_public_path__ + "static/media/add-product.018bfada.svg";